// Uses the same normalized company identity and untouched bank values as the viewer.
export function renderCobrancaPdf(doc, { identity, logo, cobranca, boleto, statusLabel, generatedAt,
  ambienteMock, cobrancaCancelada, barcode, qrCode, formatMoney, formatDate }) {
  const margin = 16;
  const width = doc.internal.pageSize.getWidth() - 2 * margin;
  const bottom = doc.internal.pageSize.getHeight() - margin;
  let y = 20;
  const room = height => { if (y + height > bottom) { doc.addPage(); y = 20; } };
  const text = (value, { x = margin, maxWidth = width, size = 10, bold = false, mono = false } = {}) => {
    if (!value) return;
    doc.setFont(mono ? 'courier' : 'helvetica', bold ? 'bold' : 'normal');
    doc.setFontSize(size);
    const lines = doc.splitTextToSize(String(value), maxWidth);
    const lineHeight = size * 0.45;
    for (const line of lines) { room(lineHeight); doc.text(line, x, y); y += lineHeight; }
    y += 2;
  };
  const imageFit = (data, x, top, maxWidth, maxHeight) => {
    const p = doc.getImageProperties(data);
    const scale = Math.min(maxWidth / p.width, maxHeight / p.height);
    doc.addImage(data, 'PNG', x, top, p.width * scale, p.height * scale);
  };
  let nameX = margin;
  if (logo) { imageFit(logo, margin, y - 4, 28, 20); nameX += 34; }
  const headerTop = y;
  const identityWidth = width - (nameX - margin) - 53;
  const right = { x: margin + width - 48, maxWidth: 48, size: 9 };
  text('RESUMO DA COBRANÇA', { ...right, bold: true });
  text(`Cobrança #${cobranca.id || '—'}`, right);
  if (cobranca.numero_contrato) text(`Contrato ${cobranca.numero_contrato}`, right);
  text(statusLabel, { ...right, bold: true });
  const referenceEnd = y;
  y = headerTop;
  text(identity.primaryName, { x: nameX, maxWidth: identityWidth, size: 14, bold: true });
  text(identity.legalName, { x: nameX, maxWidth: identityWidth, size: 9 });
  text(identity.cnpj ? `CNPJ ${identity.cnpj}` : '', { x: nameX, maxWidth: identityWidth, size: 9 });
  for (const line of [...identity.addressLines, ...identity.contacts]) text(line, { x: nameX, maxWidth: identityWidth, size: 8 });
  y = Math.max(y, referenceEnd, headerTop + (logo ? 20 : 0)) + 5;
  if (cobrancaCancelada) text('COBRANÇA CANCELADA — NÃO PAGAR', { bold: true });
  else if (ambienteMock) text('AMBIENTE MOCK — DOCUMENTO SEM VALOR BANCÁRIO', { bold: true });
  for (const [label, value] of [
    ['Aluno', cobranca.aluno_nome], ['Pagador', cobranca.pagador_nome],
    ['Valor', formatMoney(cobranca.valor_atual)], ['Vencimento', formatDate(cobranca.data_vencimento_atual)],
    ['Nosso número', boleto.nosso_numero], ['Seu número', boleto.seu_numero]
  ]) text(`${label}: ${value || '—'}`);
  room(35);
  text('Linha digitável', { bold: true });
  text(boleto.linha_digitavel || 'Não disponível.', { mono: true });
  if (barcode) {
    room(30);
    imageFit(barcode, margin, y, width, 18);
    y += 21;
    text(boleto.codigo_barras, { size: 8, mono: true });
  }
  if (boleto.pix_copia_cola) {
    doc.setFont('courier', 'normal'); doc.setFontSize(8);
    const pixWidth = qrCode ? width - 52 : width;
    const pixLines = doc.splitTextToSize(boleto.pix_copia_cola, pixWidth);
    room(Math.max(48, pixLines.length * 3.6 + 18));
    text('PIX', { bold: true });
    const pixTop = y;
    if (qrCode) imageFit(qrCode, margin, pixTop, 42, 42);
    const pixX = margin + (qrCode ? 52 : 0);
    text(boleto.pix_copia_cola, { x: pixX, maxWidth: pixWidth, mono: true, size: 8 });
    y = Math.max(y, pixTop + (qrCode ? 45 : 0));
  }
  y += 5;
  room(35);
  const beneficiary = cobranca.beneficiario_documento;
  if (beneficiary?.nome) {
    text('BENEFICIÁRIO', { size: 8, bold: true });
    text(beneficiary.nome, { size: 9 });
  }
  if (beneficiary?.documento) text(`CPF/CNPJ ${beneficiary.documento}`, { size: 8 });
  if (beneficiary?.endereco) text(Object.values(beneficiary.endereco).filter(Boolean).join(' · '), { size: 8 });
  text(cobrancaCancelada ? 'Cobrança cancelada. Documento mantido somente para histórico.' : ambienteMock
    ? 'Documento gerado para homologação. Não efetue pagamento.'
    : 'Este resumo não substitui o boleto ou PDF oficial fornecido pelo provedor bancário.', { size: 8 });
  text(`Documento gerado pelo EQUESTRO · ${generatedAt}`, { size: 8 });
}
